var dogfoodConfig = {
    aadUrl: 'https://login.windows-ppe.net/',
    agreementApi: 'https://main.df.marketplaceagreement.azure.net',
    agreementAppId: 'a2127aa9-30a9-4160-b0d8-9c24a6694006',
    appsourceUrl: 'https://appgallery.spza-staging.net',
    azureManagementApi: 'https://api-dogfood.resources.windows-int.net',
    commerceAppId: 'https://commerceapi.officeppe.net',
    graphApi: 'https://graph.microsoft-ppe.com',
    i18nResources: 'https://static.df.cloudmarketplace.microsoft.com/localization',
    jarvisApi: 'https://jarvisapi.account.microsoft-int.com',
    marketplaceLeadsAppId: '19ca5130-62f0-4fb6-bd90-08a9b5582f06',
    marketplaceLeadsUrl: 'https://main.df.marketplaceleads.azure.net',
    partnersApi: 'https://main.int.marketplacepartnerdirectory.azure-test.net/api',
    pifdApi: 'https://pifd.cp.microsoft-int.com',
    searchApi: 'https://df.catalogrp.azure-test.net',
    telemetryEnv: 'DF'
};

export { dogfoodConfig };
